module.exports = __webpack_public_path__ + "img/ie.f3380d01.svg";